export const setSessionsArr = (state,sesionsArr)=>{
    state.session = sesionsArr
};